export default __webpack_public_path__ + "4b8adde80b3faaa1c33bfb38ebda8b9d.svg";